import { FC, useMemo } from 'react';
import { UserGroupEnum } from 'videoservice-openapi-react';
import { FilterProvider } from 'entities/broadcast';
import { IFilterContextKeys } from 'entities/broadcast';
import { ECustomMappingType } from 'entities/broadcast';
import { useHasRole } from 'shared/lib/role';
import { BroadcastsContent } from './broadcasts-content';

export const BroadcastsPage: FC = () => {
  const { hasRole } = useHasRole();

  const defaultFilterValues: Partial<IFilterContextKeys> = useMemo<
    Partial<IFilterContextKeys>
  >(
    () => ({
      mappingType: hasRole(UserGroupEnum.CUSTOMER)
        ? ECustomMappingType.LINKED
        : ECustomMappingType.ALL,
    }),
    [hasRole],
  );

  return (
    <FilterProvider
      defaultValues={defaultFilterValues}
      storeKey="broadcasts-page-filters"
    >
      <BroadcastsContent />
    </FilterProvider>
  );
};

export const Component = BroadcastsPage;

Component.displayName = 'BroadcastsPage';
